import { IsBoolean } from 'class-validator';

export class TableRestartReqDto {
  @IsBoolean()
  restartGameserver: boolean;
}
